const protectedWords: string[]
  = ['Mercedes-Benz', 'Mercedes-Benz AMG', 'Mercedes-Maybach', 'Mercedes', 'Klasse', 'Class']
    .sort((a, b) => b.length - a.length);

export function protectWords (elem: HTMLElement): void {
  let { innerHTML } = elem;
  const foundWords: string[] = [];
  protectedWords.forEach((word) => {
    if (innerHTML.indexOf(word) !== -1) {
      const wordAlreadyProtected = !foundWords.some((foundWord) => foundWord.indexOf(word) > -1);
      foundWords.push(word);
      if (wordAlreadyProtected) {
        innerHTML = innerHTML.replace(word, `<span class="no-break">${word}</span>`);
      }
    }
  });
  elem.innerHTML = innerHTML;
}

export function checkForNoBreakClass (text: string): object {
  if (protectedWords.some((protectedWord) => text.indexOf(protectedWord) !== -1)) {
    return { 'no-break': true };
  }
  return {};
}
